module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step3_Image0.fa939469.jpg";